import { Injectable } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { apps } from "./background.constant";
import { Location } from '@angular/common';
import { PARAMETER_KEYS, SESSION_KEYS } from 'src/app/shared/constants/params.constant';
import { StorageService } from 'src/app/shared/service/storage.service';
import { AppDetail } from "../../../utils/interfaces/background.interface";

@Injectable()
export class BackgroundService {

  appDetail?: AppDetail;

  constructor(
    private route: ActivatedRoute,
    private location: Location,
    private storageService: StorageService
  ) {
    const uuidSE = this.storageService.get(SESSION_KEYS.UUID);
    if (!uuidSE) {
      const currentUrl = this.location.path()?.split('?')?.find(i => i) || '';
      this.captureQueryLocation(currentUrl);
    }

    this.route.queryParamMap.subscribe(paramsAs => {
      const socioName = paramsAs.get(PARAMETER_KEYS.SOCIO);
      const tokenJWT = paramsAs.get(PARAMETER_KEYS.JWT);
      let app = 'default';
      if (socioName && tokenJWT) {
        this.saveSessionStorage(tokenJWT, socioName);
        app = socioName;
      } else {
        const uuidSE = this.storageService.get(SESSION_KEYS.UUID);
        const socioSE = this.storageService.get(SESSION_KEYS.SOCIO);
        if (uuidSE && socioSE) {
          app = socioSE;
        }
      }

      this.appDetail = apps.has(app) ? apps.get(app) : apps.get('default');
    });
  }

  captureQueryLocation(currentUrlPath: string): void {
    const listx = currentUrlPath?.split('&');
    const appValue = this.searchQuery(listx, PARAMETER_KEYS.SOCIO);
    const tokenValue = this.searchQuery(listx, PARAMETER_KEYS.JWT);
    if (tokenValue) this.saveSessionStorage(tokenValue, appValue);
  }

  searchQuery(listx: string[], param: string): string {
    const app = listx.find(i => i.includes(param));
    return app?.replace(`${param}=`, '') || '';
  }

  saveSessionStorage(uuid: string, socio: string) {
    this.storageService.set(SESSION_KEYS.UUID, uuid);
    this.storageService.set(SESSION_KEYS.SOCIO, socio);
  }
}
